module.exports = __webpack_public_path__ + "static/img/profile.968fda7f.svg";